export const actions = {
    PAGINATOR: {
        DATA_FETCHED: Symbol('DATA_FETCHED'),
        CHANGE_PAGE: Symbol('CHANGE_PAGE'),
    }
};